import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormControl
} from '@angular/forms';
import { TextareaInputComponent } from '../form/textarea-input/textarea-input.component';

export interface LanguageFeedbackModel {
  rating: number;
  comment: string;
  language: string;
  
}

@Component({
  selector: 'app-language-feedback',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextareaInputComponent
  ],
  templateUrl: './language-feedback.component.html',
  styleUrl: './language-feedback.component.scss',
})
export class LanguageFeedbackComponent {
  @Input() currentLanguage = 'en';

  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<LanguageFeedbackModel>();

  isOpen = false;
  rating = 0;
  comment = new FormControl('');

  readonly ratings = [1, 2, 3, 4, 5];

  open(): void {
    this.isOpen = true;
    this.rating = 0;
    this.comment.reset();
  }

  close(): void {
    this.isOpen = false;
    this.closed.emit();
  }

  selectRating(rating: number): void {
    this.rating = rating;
  }

  submit(): void {
    if (!this.rating) {
      return;
    }

    const feedback: LanguageFeedbackModel = {
      rating: this.rating,
      comment: this.comment.value?.trim() || '',
      language: this.currentLanguage,
    };

    this.submitted.emit(feedback);
    this.close();
  }
}